import { observable } from 'mobx';
import type { Moment } from 'moment';
import moment from 'moment';

export type RakutenTravelRConnectBookingInfoResponseArgs = {
  id: number;
  hotel_element_id: number;
  hotel_element_guest_id?: number;
  traveler_information_id?: number;
  hotel_reservation_id: string;
  amount_after_tax: number;
  canceled_at?: string | null;
  canceled_by_id?: number | null;
};

export type RakutenTravelRConnectBookingInfoArgs = {
  id: number;
  hotelElementId: number;
  hotelElementGuestId?: number;
  travelerInformationId?: number;
  hotelReservationId: string;
  amountAfterTax: number;
  canceledAt?: Moment | null;
  canceledById?: number | null;
};

export const convertRakutenTravelRConnectBookingInfoResponseToArgs = (
  response: RakutenTravelRConnectBookingInfoResponseArgs
): RakutenTravelRConnectBookingInfoArgs => {
  return {
    id: response.id,
    hotelElementId: response.hotel_element_id,
    hotelElementGuestId: response.hotel_element_guest_id,
    travelerInformationId: response.traveler_information_id,
    hotelReservationId: response.hotel_reservation_id,
    amountAfterTax: response.amount_after_tax,
    canceledAt: response.canceled_at ? moment(response.canceled_at) : null,
    canceledById: response.canceled_by_id
  };
};

export default class RakutenTravelRConnectBookingInfo {
  @observable id: number;
  @observable hotelElementId: number;
  @observable hotelElementGuestId?: number;
  @observable travelerInformationId?: number;
  @observable hotelReservationId: string;
  @observable amountAfterTax: number;
  @observable canceledAt?: Moment | null;
  @observable canceledById?: number | null;

  constructor(args: RakutenTravelRConnectBookingInfoArgs) {
    this.id = args.id;
    this.hotelElementId = args.hotelElementId;
    this.hotelElementGuestId = args.hotelElementGuestId;
    this.travelerInformationId = args.travelerInformationId;
    this.hotelReservationId = args.hotelReservationId;
    this.amountAfterTax = args.amountAfterTax;
    this.canceledAt = args.canceledAt;
    this.canceledById = args.canceledById;
  }
}
